var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdsClick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1431_3206",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1431_3206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.0575 84.8075C50.7883 84.0067 45.545 81.2758 41.3275 76.615C37.1092 71.955 35 66.4167 35 60C35 53.0558 37.4304 47.1529 42.2912 42.2913C47.1529 37.4304 53.0558 35 60 35C66.4167 35 71.955 37.0929 76.615 41.2787C81.2758 45.4646 84.0067 50.6921 84.8075 56.9613L79.4037 55.375C78.3254 50.875 76.0037 47.1875 72.4388 44.3125C68.8729 41.4375 64.7267 40 60 40C54.5 40 49.7917 41.9583 45.875 45.875C41.9583 49.7917 40 54.5 40 60C40 64.75 41.4533 68.9167 44.36 72.5C47.2675 76.0833 50.9392 78.4167 55.375 79.5L57.0575 84.8075ZM63.0575 104.846C62.5483 104.949 62.0388 105 61.5288 105H60C53.775 105 47.925 103.819 42.45 101.458C36.975 99.0958 32.2125 95.8908 28.1625 91.8425C24.1125 87.7942 20.9063 83.0333 18.5438 77.56C16.1813 72.0875 15 66.2396 15 60.0163C15 53.7938 16.1808 47.9433 18.5425 42.465C20.9042 36.9875 24.1092 32.2225 28.1575 28.17C32.2058 24.1175 36.9667 20.9096 42.44 18.5462C47.9125 16.1821 53.7604 15 59.9837 15C66.2062 15 72.0567 16.1812 77.535 18.5437C83.0125 20.9062 87.7775 24.1125 91.83 28.1625C95.8825 32.2125 99.0904 36.975 101.454 42.45C103.818 47.925 105 53.775 105 60V61.4813C105 61.9746 104.949 62.4679 104.846 62.9613L100 61.5V60C100 48.8333 96.125 39.375 88.375 31.625C80.625 23.875 71.1667 20 60 20C48.8333 20 39.375 23.875 31.625 31.625C23.875 39.375 20 48.8333 20 60C20 71.1667 23.875 80.625 31.625 88.375C39.375 96.125 48.8333 100 60 100H61.5L63.0575 104.846ZM98.7788 103.942L74.8075 79.875L70.1925 93.8463L60 60L93.8463 70.1925L79.875 74.8075L103.942 98.7788L98.7788 103.942Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsClick);
export default __webpack_public_path__ + "static/media/ads_click.7d357d1a85ed75546d40a88808ddc68b.svg";
export { ForwardRef as ReactComponent };